import React from 'react';
import PropTypes from 'prop-types';

/**
 * The tinted pill the prototype uses for every status.
 *
 * The mapping lives here rather than in each page so that "Booked" is the same
 * green everywhere. Anything unrecognised falls back to neutral instead of
 * guessing — a status nobody has classified should look unremarkable, not
 * alarming.
 */
const TONE = {
  booked: 'ok',
  success: 'ok',
  confirmed: 'ok',
  paid: 'ok',
  failure: 'bad',
  failed: 'bad',
  error: 'bad',
  cancelled: 'warn',
  canceled: 'warn',
  expired: 'warn',
  pending: 'info',
  authorized: 'info'
};

export default function StatusPill({ status, children }) {
  const tone = TONE[String(status || '').toLowerCase()] || 'neutral';

  return <span className={`next-pill next-pill--${tone}`}>{children || status || '—'}</span>;
}

StatusPill.propTypes = {
  status: PropTypes.string,
  children: PropTypes.node
};
